const Dashboard = () => import(
    "../../../components/application/statement_hostel/Layouts/CommissionAppProcessing/Dashboard.vue"
    );

const SelectFacultyPlaces = () => import(
    "../../../components/application/statement_hostel/Layouts/CommissionAppProcessing/SelectFacultyPlaces.vue"
    );

export const routes = [
    {
        path: '/statement_hostel',
        name: 'statement_hostel',
        component: Dashboard,
    },
    {
        path: '/statement_hostel/commissions/dashboard',
        name: 'commissions-dashboard',
        component: SelectFacultyPlaces,
        props: route => ({ department_id: route.query.department_id })
    }
]